export default __webpack_public_path__ + "img/badass.f24376e3.svg";